import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';

/**
 * @link https://reactrouter.com/web/guides/scroll-restoration 참고
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
